/**
 * Quiet Authority empty state — mono eyebrow + serif line + optional body and
 * action. Promoted from the inline pattern FileNoteSessionsTab had so every
 * "nothing here yet" surface reads the same.
 *
 * `inline` drops the card frame — use it inside an existing card, a section,
 * or a table cell where a second border would double up.
 */
export function QAEmpty({
  eyebrow,
  title,
  children,
  action,
  inline = false,
}: {
  eyebrow?: string;
  title: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  inline?: boolean;
}) {
  return (
    <div className={`text-center text-ink-mute ${inline ? 'py-10' : 'qa-card p-8'}`}>
      {eyebrow && <p className="qa-eyebrow mb-3">{eyebrow}</p>}
      <p className="qa-h3 text-ink-soft">{title}</p>
      {children && <p className="text-sm mt-2">{children}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
